module.exports = __webpack_public_path__ + "static/media/Degular-Bold.d8cda5d1.ttf";